module.exports = __webpack_public_path__ + "img/assets_bg.6b6550fa.6b6550fa.png";